module.exports = __webpack_public_path__ + "img/logo.d50be462.png";